import styled from 'styled-components';

import FooterBase from './FooterBase';

const Footer = styled(FooterBase)`
  text-align: right;
  padding: 1.5rem;
  font-size: calc(0.5rem + 1vmin);
  background-color: black;
`;

export default Footer;
